import { createSlice } from "@reduxjs/toolkit";
import { wasteStreamsApi } from "../api/wasteStreamsApi";

const initialState = {
    wasteStreams: [],
    selectedWasteStream: null,
    loading: false,
    error: null
};

const wasteStreamsSlice = createSlice({
    name: "wasteStreams",
    initialState,
    reducers: {
        setSelectedWasteStream: (state, action) => {
            state.selectedWasteStream = action.payload;
        },
        clearSelectedWasteStream: (state) => {
            state.selectedWasteStream = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle get waste streams
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreams.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreams.matchFulfilled, (state, action) => {
                state.loading = false;
                state.wasteStreams = action.payload;
            })
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreams.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle get waste stream by ID
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreamById.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreamById.matchFulfilled, (state, action) => {
                state.loading = false;
                state.selectedWasteStream = action.payload;
            })
            .addMatcher(wasteStreamsApi.endpoints.getWasteStreamById.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle create waste stream
            .addMatcher(wasteStreamsApi.endpoints.createWasteStream.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(wasteStreamsApi.endpoints.createWasteStream.matchFulfilled, (state, action) => {
                state.loading = false;
                state.wasteStreams.push(action.payload);
            })
            .addMatcher(wasteStreamsApi.endpoints.createWasteStream.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle update waste stream
            .addMatcher(wasteStreamsApi.endpoints.updateWasteStream.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(wasteStreamsApi.endpoints.updateWasteStream.matchFulfilled, (state, action) => {
                state.loading = false;
                state.selectedWasteStream = action.payload;
                const index = state.wasteStreams.findIndex(stream => stream.ROWID === action.payload.ROWID);
                if (index !== -1) {
                    state.wasteStreams[index] = action.payload;
                }
            })
            .addMatcher(wasteStreamsApi.endpoints.updateWasteStream.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle delete waste stream
            .addMatcher(wasteStreamsApi.endpoints.deleteWasteStream.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(wasteStreamsApi.endpoints.deleteWasteStream.matchFulfilled, (state, action) => {
                state.loading = false;
                state.wasteStreams = state.wasteStreams.filter(stream => stream.ROWID !== action.meta.arg);
                if (state.selectedWasteStream?.ROWID === action.meta.arg) {
                    state.selectedWasteStream = null;
                }
            })
            .addMatcher(wasteStreamsApi.endpoints.deleteWasteStream.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
});

export const { setSelectedWasteStream, clearSelectedWasteStream } = wasteStreamsSlice.actions;
export default wasteStreamsSlice.reducer;